// Planos da Tiny que possuem cota de API (chamadas por minuto). O valor enviado
// para a config key "PLAN" deve bater com o resolver do back-end (TinyPlanEnum):
// crescer/evoluir/potencializar. O plano "Começar" (0 chamadas/min) nao e listado
// porque a integracao nao funciona nele; contas sem plano definido caem no default
// Crescer (30/min) no back-end.
export const planOptions = [
  { label: "Crescer (30 req/min)", value: "crescer" },
  { label: "Evoluir (60 req/min)", value: "evoluir" },
  { label: "Potencializar (120 req/min)", value: "potencializar" }
];
